// URL redirect mappings for SEO-friendly category URLs
export const categoryRedirects: Record<string, string> = {
  // Canadian provinces
  'ontario': 'ontario-youth-baseball',
  'alberta': 'alberta-youth-baseball',
  'british-columbia': 'british-columbia-youth-baseball',
  'quebec': 'quebec-youth-baseball',
  'saskatchewan': 'saskatchewan-youth-baseball',
  'manitoba': 'manitoba-youth-baseball',
  'nova-scotia': 'nova-scotia-youth-baseball',
  'new-brunswick': 'new-brunswick-youth-baseball',
  'newfoundland-labrador': 'newfoundland-labrador-youth-baseball',
  'prince-edward-island': 'prince-edward-island-youth-baseball',
  'northwest-territories': 'northwest-territories-youth-baseball',
  'nunavut': 'nunavut-youth-baseball',
  'yukon': 'yukon-youth-baseball',
  
  // US states
  'california': 'california-youth-baseball',
  'new-york': 'new-york-youth-baseball',
  'massachusetts': 'massachusetts-youth-baseball',
  'michigan': 'michigan-youth-baseball',
  'minnesota': 'minnesota-youth-baseball',
  'illinois': 'illinois-youth-baseball',
  'pennsylvania': 'pennsylvania-youth-baseball',
  'colorado': 'colorado-youth-baseball',
  'connecticut': 'connecticut-youth-baseball',
  'new-jersey': 'new-jersey-youth-baseball',
  'wisconsin': 'wisconsin-youth-baseball',
  'ohio': 'ohio-youth-baseball',
  'alaska': 'alaska-youth-baseball',
  'new-hampshire': 'new-hampshire-youth-baseball',
  'vermont': 'vermont-youth-baseball',
  'maine': 'maine-youth-baseball',
  'rhode-island': 'rhode-island-youth-baseball',
  'north-dakota': 'north-dakota-youth-baseball',
  'montana': 'montana-youth-baseball',
  'washington': 'washington-youth-baseball',
  
  // Generic categories
  'equipment': 'youth-baseball-equipment',
  'training': 'youth-baseball-training',
  'coaching': 'youth-baseball-coaching',
  'general': 'general-youth-baseball-discussion',
  'tournaments': 'youth-baseball-tournaments',
};

export const getRedirectUrl = (slug: string): string | null => {
  return categoryRedirects[slug] || null;
};

export const shouldRedirect = (slug: string): boolean => {
  return slug in categoryRedirects;
};